import { useState } from 'react'
import { useTimeout } from 'usehooks-ts'

import { MILLISECONDS_IN_A_SECOND } from '@/common/utils/time'

const SLOW_LOADING_DELAY_MS = 2 * MILLISECONDS_IN_A_SECOND
const VERY_SLOW_LOADING_DELAY_MS = 10 * MILLISECONDS_IN_A_SECOND

/**
 * The message to show while data loads: none at first, then a note after 2 seconds and another
 * after 10 seconds. The time starts when the component that calls it mounts, so call it in the
 * component that only shows while loading (for example `LoadingOverlay`).
 */
export const useSlowLoadingMessage = (): string => {
  const [message, setMessage] = useState<string>('')

  useTimeout(
    () => setMessage('Please hold tight while we process your data.'),
    SLOW_LOADING_DELAY_MS
  )

  useTimeout(
    () =>
      setMessage(
        `This is taking a while, please check back later —
        but do not close this page or you will have to begin again.`
      ),
    VERY_SLOW_LOADING_DELAY_MS
  )

  return message
}
